var reqwestRequest = require('./reqwestRequest');
module.exports = require('../lib/clientBuilder')(reqwestRequest);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/okta-auth-js/reqwest/index.js
// module id = 551
// module chunks = 0